import { motion } from "framer-motion";
import banner3Img from "../assets/Banner-3.png";

export default function HealthIDCard() {
  return (
    <motion.img
      initial={{ y: 30, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7 }}
      viewport={{ once: true }}
      src={banner3Img}
      alt="Saaluvars Health Banner"
      className="h-auto object-cover mx-auto"
      // style={{ width: 'calc(100% - 15px)' }}
      style={{ width: '90%' }}
      data-testid="health-id-card"
      draggable="false"
    />
  );
}
